<section class="steps-form-section">
  <div class="section-row">
    <app-general-data
      [viewModel]="generalDataViewModel"
      (onChooseContract)="onChooseContract()"
      (onCloseModalContract)="onCloseModalContract()"
    ></app-general-data>
    @if (showDescription) {
      <div class="block">
        <h3 class="dsm34-headline-6--book dsm34--mb-xs">Descrição</h3>
        <dsm34-form-field>
          <dsm34-label> Descreva aqui o pedido * </dsm34-label>
          <textarea
            dsm34-input
            dsm34-count
            [formControl]="$any(form.get('description'))"
            rows="2"
            maxlength="350"
            type="text"
            class="dsm34--p-none"
          ></textarea>
          @if ($any(form.get('description')).hasError('required')) {
            <dsm34-error> O campo é obrigatório </dsm34-error>
          }
        </dsm34-form-field>
      </div>
    }

    @if (showAttachments) {
      <div class="block">
        <h3 class="dsm34-headline-6--book dsm34--mb-xs">Anexos</h3>
        <dsm34-form-field>
          <dsm34-upload
            [multiple]="true"
            [formControl]="$any(form.get('attachments'))"
            [multiple]="maxFileAccepted() > 1"
            [fileList]="uploadFilelist"
            [maxFileAccepted]="maxFileAccepted()"
            [maxSizeAccepted]="maxSizeAccepted()"
            [accept]="fileTypesAccepted()"
            (errorList)="showErrors($event)"
          >
            <h1 class="dsm34--mb-none" title>Clique para Carregar</h1>
            <p class="dsm34--mb-none" content>
              Pode anexar múltiplos ficheiros do tipo pdf, jpg, jpeg, png, xlsx, csv, doc, docx, sgl, sgl_v2, zip. Cada
              ficheiro deverá ter no máximo {{ bytesConverted }}.
            </p>
          </dsm34-upload>
        </dsm34-form-field>

        <dsm34-filelist
          #uploadFilelist
          [files]="$any(form.get('attachments')).value"
          class="dsm34--mt-md"
          direction="column"
        >
          <ng-template dsm34ImplicitTemplate let-file>
            <dsm34-svg name="documentacao" color="main-yellow" size="lg" />

            <div class="dsm34--d-flex dsm34--flex-column dsm34--flex-fill">
              <div class="dsm34-highlight-small--book">{{ file.name }}</div>
              <span class="dsm34-body-2--regular dsm34--neutral-dark-grey">
                {{ file | dsm34FileSize }}
              </span>
            </div>

            <div>
              <button type="button" dsm34-button class="dsm34--ml-none" round (click)="uploadFilelist.onRemove(file)">
                <dsm34-svg name="apagar" size="md" />
              </button>
            </div>
          </ng-template>
        </dsm34-filelist>
      </div>
    }
  </div>
</section>
<section class="steps-buttons-section">
  <div class="section-row">
    <app-submission-bar
      (submit)="submit()"
      backButtonText="Voltar"
      (back)="back()"
      clearButtonText="Limpar"
      (clear)="clear()"
      submitButtonText="Submeter"
      [submitButtonDisabled]="!form?.valid"
    >
    </app-submission-bar>
  </div>
</section>
